export const getEnv = (key: string): string | undefined => {
  if (typeof window !== 'undefined' && (window as any)._env_ && (window as any)._env_[key] !== undefined) {
    return (window as any)._env_[key];
  }
  return process.env[key];
};
